<div class="report-page-container" *ngIf="!isLoadingReportList && !isLoadingRegisterFormOptions && !isLoadingLabels">
	<div class="report-header">
		<div class="title">
			<span *ngIf="pageView === 'report-list'">{{ labels.lbl_geral_reports }}</span>
			<div *ngFor="let reportOption of reportOptionArray">
				<span
					*ngIf="
						(reportOption.spreadsheetView === spreadsheetView && pageView === 'register') ||
						(reportOption.spreadsheetView === spreadsheetView && pageView === 'spreadsheet') ||
						(reportOption.spreadsheetView === spreadsheetView && pageView === 'edit')
					"
					>{{ labels.lbl_geral_relatorio }} {{ labels[reportOption.label] }}</span
				>
			</div>
		</div>

		<div class="button-container">
			<a class="button" [routerLink]="'/report'" *ngIf="pageView === 'report-list'">{{ labels.lbl_geral_voltar }}</a>
			<div class="button" (click)="exportExcel()" *ngIf="pageView === 'spreadsheet'">{{ labels.lbl_geral_exportar_excel }}</div>
			<div
				class="button"
				(click)="pageView = 'report-list'; unselectAllForm()"
				*ngIf="pageView === 'register' || pageView === 'spreadsheet' || pageView === 'edit'">
				{{ labels.lbl_geral_voltar }}
			</div>
		</div>
	</div>

	<div class="report-body">
		<ng-container *ngIf="pageView === 'report-list'">
			<div class="report-list-container">
				<div>
					{{ labels.lbl_selecione_para_continuar }}

					<div
						class="report-option"
						(click)="pageView = reportOption.pageView; spreadsheetView = reportOption.spreadsheetView; reportOption.function()"
						*ngFor="let reportOption of reportOptionArray">
						<span *ngIf="reportOption.icon"><fa-icon [icon]="reportOption.icon"></fa-icon></span>
						<span>{{ labels[reportOption.label] }}</span>
					</div>
				</div>
			</div>
		</ng-container>

		<ng-container *ngIf="pageView === 'register' || pageView === 'edit'">
			<div class="register-report-container">
				<div class="title" (click)="isRegisterAdvancedOpen = !isRegisterAdvancedOpen">
					<span>{{ labels.lbl_geral_campos_disponiveis }}</span>
					<span [ngClass]="{ 'rotate-90': isRegisterAdvancedOpen }"><fa-icon [icon]="faAngleRight"></fa-icon></span>
				</div>
				<div class="advanced-container" *ngIf="isRegisterAdvancedOpen">
					<div class="tip">{{ labels.lbl_incluir_campos_final_relatorio }}:</div>
					<div class="custom-options-container mb-3">
						<div class="custom-option fixed selected">{{ labels.lbl_filtros_aplicaveis }}</div>
						<div
							class="custom-option"
							[ngClass]="{ selected: formOption.selected === true }"
							*ngFor="let formOption of registerFormOptions"
							(click)="
								formOption.selected = !formOption.selected;
								formOption.selected === true ? selectForm(formOption) : unselectForm(formOption)
							">
							{{ labels[formOption.label] }}
						</div>
					</div>
				</div>

				<div class="custom-options-container">
					<div class="tip">{{ labels.lbl_selecione_filtro_info }}</div>

					<div class="custom-option-input" *ngFor="let formOption of selectedFormOptions">
						<span
							class="label"
							*ngIf="
								formOption.inputType !== 'boolean' && formOption.inputType !== 'period-date' && formOption.hidden !== true
							"
							>{{ labels[formOption.label] }}</span
						>
						<input
							type="text"
							(input)="formOption.values[0] = $event.target.value"
							[value]="formOption.values[0]"
							*ngIf="formOption.inputType === 'string'" />
						<select (change)="formOption.values[0] = $event.target.value" *ngIf="formOption.inputType === 'select'">
							<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
							<option
								*ngFor="let option of formOption.items"
								[selected]="formOption.values[0] === option.values"
								[value]="option.values">
								{{ labels[option.label] ? labels[option.label] : option.name }}
							</option>
						</select>

						<div class="date-container" *ngIf="formOption.inputType === 'period-date'">
							<div class="date-input-container">
								<span class="label">{{ labels[formOption.label] }}:</span
								><input type="date" (change)="formOption.values[0] = $event.target.value" [value]="formOption.values[0]" />
							</div>
						</div>
					</div>
				</div>

				<div class="button-container">
					<div class="button mt-2 mb-4" (click)="createReport()" *ngIf="pageView === 'register'">
						{{ labels.lbl_create_report }}
					</div>
				</div>
			</div>
		</ng-container>

		<ng-container *ngIf="pageView === 'spreadsheet'">
			<div>
				<table id="excel-table">
					<tr>
						<th *ngIf="spreadsheetView === 'consumables' || spreadsheetView === 'newItems' || spreadsheetView === 'stockLoan'">
							{{ labels.lbl_cmdb }}
						</th>
						<th *ngIf="spreadsheetView === 'consumables' || spreadsheetView === 'newItems' || spreadsheetView === 'stockLoan'">
							{{ labels.lbl_geral_identificacao }}
						</th>
						<th *ngIf="spreadsheetView === 'consumables'">{{ labels.lbl_geral_usuario }}</th>
						<th *ngIf="spreadsheetView === 'consumables'">{{ labels.lbl_geral_responsavel }}</th>
						<th *ngIf="spreadsheetView === 'consumables' || spreadsheetView === 'newItems' || spreadsheetView === 'stockLoan'">
							{{ labels.lbl_geral_local }}
						</th>
						<th *ngIf="spreadsheetView === 'consumables' || spreadsheetView === 'newItems'">{{ labels.lbl_localidade }}</th>
						<th *ngIf="spreadsheetView === 'consumables'">{{ labels.lbl_geral_tipo }}</th>
						<th *ngIf="spreadsheetView === 'consumables'">{{ labels.lbl_edocs_documento }}</th>
						<th *ngIf="spreadsheetView === 'consumables'">{{ labels.lbl_geral_observacoes }}</th>
						<th *ngIf="spreadsheetView === 'consumables' || spreadsheetView === 'newItems'">{{ labels.lbl_geral_quan_est }}</th>
						<th *ngIf="spreadsheetView === 'consumables'">{{ labels.lbl_geral_entrada }}</th>
						<th *ngIf="spreadsheetView === 'consumables'">{{ labels.lbl_geral_saida }}</th>
						<th *ngIf="spreadsheetView === 'consumables' || spreadsheetView === 'newItems'">{{ labels.lbl_geral_data }}</th>
						<th *ngIf="spreadsheetView === 'consumables'">{{ labels.lbl_geral_movement_date }}</th>
						<th *ngIf="spreadsheetView === 'stockLoan'">{{ labels.lbl_geral_quan_pen }}</th>
						<th *ngIf="spreadsheetView === 'stockLoan'">{{ labels.lbl_geral_data_retorno_esperada }}</th>
						<th *ngIf="spreadsheetView === 'stockLoan'">{{ labels.lbl_geral_data_retorno }}</th>
						<th *ngIf="spreadsheetView === 'stockLoan'">{{ labels.lbl_geral_responsavel }}</th>
					</tr>
					<tr *ngFor="let item of consumablesInterface">
						<td *ngIf="spreadsheetView === 'consumables' || spreadsheetView === 'newItems' || spreadsheetView === 'stockLoan'">
							{{ item.cmdb_id }}
						</td>
						<td *ngIf="spreadsheetView === 'consumables' || spreadsheetView === 'newItems' || spreadsheetView === 'stockLoan'">
							{{ item.identification }}
						</td>
						<td *ngIf="spreadsheetView === 'consumables'">{{ item.full_name }}</td>
						<td *ngIf="spreadsheetView === 'consumables'">{{ item.name_responsable }}</td>
						<td *ngIf="spreadsheetView === 'consumables' || spreadsheetView === 'newItems' || spreadsheetView === 'stockLoan'">
							{{ item.location }}
						</td>
						<td *ngIf="spreadsheetView === 'consumables' || spreadsheetView === 'newItems'">{{ item.site }}</td>
						<td *ngIf="spreadsheetView === 'consumables'">{{ labels[item.label] }}</td>
						<td *ngIf="spreadsheetView === 'consumables'">{{ item.document }}</td>
						<td *ngIf="spreadsheetView === 'consumables'">{{ item.observation }}</td>
						<td *ngIf="spreadsheetView === 'consumables' || spreadsheetView === 'newItems'">{{ item.qtd }}</td>
						<td *ngIf="spreadsheetView === 'consumables'">{{ item.in }}</td>
						<td *ngIf="spreadsheetView === 'consumables'">{{ item.out }}</td>
						<td *ngIf="spreadsheetView === 'consumables' || spreadsheetView === 'newItems'">{{ item.creationDate }}</td>
						<td *ngIf="spreadsheetView === 'consumables'">{{ item.movementDate }}</td>
						<td *ngIf="spreadsheetView === 'stockLoan'">{{ item.loan }}</td>
						<td *ngIf="spreadsheetView === 'stockLoan'">{{ item.expectedReturnDate }}</td>
						<td *ngIf="spreadsheetView === 'stockLoan'">{{ item.returnDate }}</td>
						<td *ngIf="spreadsheetView === 'stockLoan'">{{ item.enduser_responsible }}</td>
					</tr>
				</table>
			</div>
		</ng-container>
	</div>
</div>

<div class="loading-container" *ngIf="isLoadingReportList || isLoadingRegisterFormOptions || isLoadingLabels">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ labels.lbl_edocs_carregando }}!</div>
</div>
